import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Programs from "../pages/programs/page";
import Piic from "../pages/piic/page";
import Ptim from "../pages/ptim/page";
import Capacity from "../pages/capacity/page";
import Ecosystem from "../pages/ecosystem/page";
import Collaborate from "../pages/collaborate/page";
import Contact from "../pages/contact/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Experts from "../pages/experts/page";
import Piarc from "../pages/piarc/page";
import Ijtai from "../pages/ijtai/page";
import Aircon from "../pages/aircon/page";
import News from "../pages/news/page";
import Media from "../pages/media/page";
import TechPartners from "../pages/tech-partners/page";
import CourseDetailPage from "../pages/capacity/CourseDetailPage";
import InnovationWing from "../pages/wings/innovation/page";
import ResearchWing from "../pages/wings/research/page";
import ReadinessWing from "../pages/wings/readiness/page";
import ExpoWing from "../pages/wings/expo/page";
import TextileEngineeringCell from "../pages/cells/textile-engineering/page";
import ManagementExcellenceCell from "../pages/cells/management-excellence/page";
import TextileProcessingCell from "../pages/cells/textile-processing/page";
import TextileMaterialsCell from "../pages/cells/textile-materials/page";
import MarketingMerchandisingCell from "../pages/cells/marketing-merchandising/page";
import TextileEfficiencyCell from "../pages/cells/textile-efficiency/page";
import SitemapPage from "../pages/sitemap/page";
import PressReleasePage from "../pages/press-release/page";
import ArticlePage from "../pages/press-release/ArticlePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/programs",
    element: <Programs />,
  },
  {
    path: "/wings/innovation",
    element: <InnovationWing />,
  },
  {
    path: "/wings/research",
    element: <ResearchWing />,
  },
  {
    path: "/wings/readiness",
    element: <ReadinessWing />,
  },
  {
    path: "/wings/expo",
    element: <ExpoWing />,
  },
  {
    path: "/cells/textile-engineering",
    element: <TextileEngineeringCell />,
  },
  {
    path: "/cells/management-excellence",
    element: <ManagementExcellenceCell />,
  },
  {
    path: "/cells/textile-processing",
    element: <TextileProcessingCell />,
  },
  {
    path: "/cells/textile-materials",
    element: <TextileMaterialsCell />,
  },
  {
    path: "/cells/marketing-merchandising",
    element: <MarketingMerchandisingCell />,
  },
  {
    path: "/cells/textile-efficiency",
    element: <TextileEfficiencyCell />,
  },
  {
    path: "/piic",
    element: <Piic />,
  },
  {
    path: "/ptim",
    element: <Ptim />,
  },
  {
    path: "/training",
    element: <Capacity />,
  },
  {
    path: "/training/course/:slug",
    element: <CourseDetailPage />,
  },
  {
    path: "/ecosystem",
    element: <Ecosystem />,
  },
  {
    path: "/collaborate",
    element: <Collaborate />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy-policy",
    element: <Privacy />,
  },
  {
    path: "/terms-conditions",
    element: <Terms />,
  },
  {
    path: "/experts",
    element: <Experts />,
  },
  {
    path: "/piarc",
    element: <Piarc />,
  },
  {
    path: "/ijtai",
    element: <Ijtai />,
  },
  {
    path: "/aircon",
    element: <Aircon />,
  },
  {
    path: "/media",
    element: <Media />,
  },
  {
    path: "/press-release/:id",
    element: <ArticlePage />,
  },
  {
    path: "/press-release",
    element: <PressReleasePage />,
  },
  {
    path: "/news",
    element: <Navigate to="/media" replace />,
  },
  {
    path: "/media-coverage",
    element: <Navigate to="/media" replace />,
  },
  {
    path: "/technology-partners",
    element: <TechPartners />,
  },
  {
    path: "/sitemap",
    element: <SitemapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;